import { NgModule } from '@angular/core';
import { DsSharedLazyModule } from '@direction/translate';
import { MiscellaneousRoutingModule, routedComponents } from './miscellaneous-routing.module';

@NgModule({
	imports: [MiscellaneousRoutingModule, DsSharedLazyModule],
	declarations: [...routedComponents],
})
export class MiscellaneousModule {}
